import { round } from "lodash";

/**
 * 数字显示
 * @param {number} num
 * @param {{
 *  space: boolean,
 *  thousand: boolean,
 *  isUpper: boolean,
 *  showPlus: boolean,
 *  fixed: number,
 * }=} options {
 *  space: 数字与单位之间增加空格,
 *  thousand: 1000时,是否显示k,
 *  isUpper: 单位是否大写,
 *  showPlus: 显示+号  例如：11w+,
 *  fixed: 小数点后保留几位,
 * }
 * @returns
 */
const displayNum = (
  num,
  { space, thousand, isUpper, showPlus = true, fixed = 1 } = {}
) => {
  if (!num) {
    return num;
  }

  let str = num + "";
  if (thousand && num < 10000 && num > 999) {
    const unit = isUpper ? "K" : "k";
    str = round(num / 1000, fixed) + (space ? " " : "") + unit;

    if (showPlus && num % 1000 === 0) {
      str = str + "+";
    }
    return str;
  } else if (num > 9999) {
    const unit = isUpper ? "W" : "w";
    str = round(num / 10000, fixed) + (space ? " " : "") + unit;

    if (showPlus && num % 10000 !== 0) {
      str = str + "+";
    }
    return str;
  }
  return str;
};

// 过千数字处理
export const displayThousandNum = (num) => {
  if (!num) {
    return num;
  }
  let str = num + "";
  if (num > 999) {
    const val = num / 1000;
    if (num % 1000 === 0) {
      str = num / 1000 + "k";
    } else {
      str = val.toFixed(1) + "k";
    }
  }
  return str;
};

export default displayNum;
